export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-page-pdf-25758be427dfa76fb6d84201e975bc6d.svg";